export enum enTipoAcompanhamento {
    Pedido = 1,
    Produto = 2
}